import "react-toastify/dist/ReactToastify.css";
import AttributeBars from "../../Dashboard/Component/CompAttributes/CompAttributes";
import { transformDataForMultibarChart } from "../../../utils/helpers";
import React, { useContext } from "react";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import Checkbox from "@mui/material/Checkbox";
import { tab } from "../BrandScore/BrandScore";

export default function AttributesOverview({ category ,isCategoryOverview=false}) {
  const discoveryCtx = useContext(DiscoveryContext);
  let attributeRef = discoveryCtx.positive_negative_attributes;
  let selectedLLM, selectedCategory;
  /*Selected LLM*/
  if (category) {
    selectedLLM = [discoveryCtx.state.selectedLLM]
    selectedCategory = category
  }
  else {
    selectedLLM = discoveryCtx.llm;
    selectedCategory = discoveryCtx.state.selectedCategory;
  }

  let positiveAttributes = {};
  selectedLLM.forEach((llm) => {
    let positiveAttr = attributeRef?.[llm]?.[selectedCategory]
      ?.find((brand) => brand.name === discoveryCtx.entity)
      ?.positives ?? []
    if (positiveAttr.length) {
      positiveAttributes[llm] = positiveAttr?.reduce((a, b) => {
        return { ...a, [b.name]: b.value };
      }, {}) ?? {}
    }
  });

  const id = "Attributes_Overview_brandOverview";
  const { checked, uniqueKey } = useIsSelectedSection({ id });

  let negativesAttributes = {};
  selectedLLM.forEach((llm) => {
    let negativeAttr = attributeRef?.[llm]?.[selectedCategory]
      ?.find((brand) => brand.name === discoveryCtx.entity)
      ?.negatives ?? []
    if (negativeAttr.length) {
      negativesAttributes[llm] = negativeAttr.reduce((a, b) => {
        return { ...a, [b.name]: b.value };
      }, {}) ?? {}
    }
  });

  let positiveAttBarChartData = transformDataForMultibarChart(
    positiveAttributes,
    false
  );
  let negativeAttBarChartData = transformDataForMultibarChart(
    negativesAttributes,
    false
  );

  return (
    <>
      {!isCategoryOverview && <div className="Heading-checkbox">
        <h5>Positive and Negative Attributes</h5>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: "Positive and Negative Attributes",
                  tab: tab.brandOverview,
                  uniqueKey
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
      </div>}
      {!isCategoryOverview &&       <hr />}

      <AttributeBars
        negativeAttributes={negativeAttBarChartData}
        positiveAttributes={positiveAttBarChartData}
        id={id}
      />
    </>
  );
};



/*
 llmData=["gpt4-0","gemini"];

 data={
 gpt4-0:{
 project_management:{
 "consting":4,
 " accessibility":5
 }
 }
 }

filterArr=["project_management","timeSheet"]
*/
